import { c as _c } from "react/compiler-runtime";
import { useTranslation } from "react-i18next";
import { DispatchStatusEnum, OrderStatusEnum, PayStatusEnum, type UserOrder, type UserOrderDetail } from "../schema";
const getStatusTextMap = (t: any): Record<OrderStatusEnum, string> => ({
  waitPay: t("order.status.waitPay"),
  paid: t("order.status.processing"),
  pushed: t("order.status.processing"),
  partSended: t("order.status.partSended"),
  sended: t("order.status.sended"),
  close: t("order.status.cancel"),
  success: t("order.status.success"),
  rejected: t("order.status.rejected"),
  timeout: t("order.status.timeout")
});

// 支付状态映射
const getPayStatusTextMap = (t: any): Record<PayStatusEnum, string> => ({
  waitPay: t("order.payStatus.waitPay"),
  paid: t("order.payStatus.paid"),
  refunding: t("order.payStatus.refunding"),
  partRefund: t("order.payStatus.partRefund"),
  refund: t("order.payStatus.refund")
});
export function ListOrderStatus(t0) {
  const $ = _c(14);
  const {
    order
  } = t0;
  const {
    t
  } = useTranslation();
  let t1;
  if ($[0] !== t) {
    t1 = getStatusTextMap(t);
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const statusTextMap = t1;
  let t2;
  if ($[2] !== t) {
    t2 = getPayStatusTextMap(t);
    $[2] = t;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const payStatusTextMap = t2;
  if (order.status === OrderStatusEnum.PART_SENDED || order.status === OrderStatusEnum.SENDED) {
    return statusTextMap[order.status];
  }
  if (order.status === OrderStatusEnum.PUSHED && order.payStatus === PayStatusEnum.REFUND) {
    let t3;
    if ($[4] !== t) {
      t3 = t("order.status.cancel");
      $[4] = t;
      $[5] = t3;
    } else {
      t3 = $[5];
    }
    let t4;
    if ($[6] !== t3) {
      t4 = <span className="text-hint font-medium">{t3}</span>;
      $[6] = t3;
      $[7] = t4;
    } else {
      t4 = $[7];
    }
    return t4;
  }
  if (order.status === OrderStatusEnum.PAID || order.status === OrderStatusEnum.PUSHED) {
    return statusTextMap[order.status];
  }
  if (order.status === OrderStatusEnum.CLOSE) {
    const firstDispatch = (order as any).dispatches?.[0];
    if (firstDispatch && (firstDispatch.status === DispatchStatusEnum.PART_EXPRESSED || firstDispatch.status === DispatchStatusEnum.EXPRESSED)) {
      return statusTextMap[OrderStatusEnum.SENDED];
    }
    const sendStatus = (order as any).sendStatus;
    if (sendStatus === DispatchStatusEnum.PART_EXPRESSED || sendStatus === DispatchStatusEnum.EXPRESSED) {
      return statusTextMap[OrderStatusEnum.SENDED];
    }
    let t3;
    if ($[8] !== t) {
      t3 = t("order.status.cancel");
      $[8] = t;
      $[9] = t3;
    } else {
      t3 = $[9];
    }
    let t4;
    if ($[10] !== t3) {
      t4 = <span className="text-hint font-medium">{t3}</span>;
      $[10] = t3;
      $[11] = t4;
    } else {
      t4 = $[11];
    }
    return t4;
  }
  if (order.payStatus === PayStatusEnum.REFUNDING || order.payStatus === PayStatusEnum.PART_REFUND || order.payStatus === PayStatusEnum.REFUND) {
    const t3 = payStatusTextMap[order.payStatus];
    let t4;
    if ($[12] !== t3) {
      t4 = <span className="text-hint font-medium">{t3}</span>;
      $[12] = t3;
      $[13] = t4;
    } else {
      t4 = $[13];
    }
    return t4;
  }
  return statusTextMap[order.status];
}
export const DetailOrderStatus = t0 => {
  const $ = _c(8);
  const {
    order
  } = t0;
  const {
    t
  } = useTranslation();
  let t1;
  if ($[0] !== t) {
    t1 = getStatusTextMap(t);
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const statusTextMap = t1;
  let t2;
  if ($[2] !== t) {
    t2 = getPayStatusTextMap(t);
    $[2] = t;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const payStatusTextMap = t2;
  if (order.status === OrderStatusEnum.PART_SENDED || order.status === OrderStatusEnum.SENDED) {
    return statusTextMap[order.status];
  }
  if (order.status === OrderStatusEnum.PUSHED && order.payStatus === PayStatusEnum.REFUND) {
    let t3;
    if ($[4] !== t) {
      t3 = t("order.status.cancel");
      $[4] = t;
      $[5] = t3;
    } else {
      t3 = $[5];
    }
    return t3;
  }
  if (order.status === OrderStatusEnum.PAID || order.status === OrderStatusEnum.PUSHED) {
    return statusTextMap[order.status];
  }
  if (order.status === OrderStatusEnum.CLOSE) {
    const firstDispatch = order.dispatches?.[0];
    if (firstDispatch && (firstDispatch.status === DispatchStatusEnum.PART_EXPRESSED || firstDispatch.status === DispatchStatusEnum.EXPRESSED)) {
      return statusTextMap[OrderStatusEnum.SENDED];
    }
    let t3;
    if ($[6] !== t) {
      t3 = t("order.status.cancel");
      $[6] = t;
      $[7] = t3;
    } else {
      t3 = $[7];
    }
    return t3;
  }
  if (order.payStatus === PayStatusEnum.REFUNDING || order.payStatus === PayStatusEnum.PART_REFUND || order.payStatus === PayStatusEnum.REFUND) {
    return payStatusTextMap[order.payStatus];
  }
  return statusTextMap[order.status];
};